import { createContext } from 'react';
import { TblModuleStore } from '../Interfaces/DataBase';

const ModuleContext = createContext<TblModuleStore[]>([]);

export default ModuleContext;
